import React from 'react';
import { TextPosition } from './ManageSlider';
import { getImage } from '../../server/server';

interface Slider {
	id?: string;
	name: string;
	description: string;
	color: string;
	backgroundColor: string;
	image: string;
	link: string;
	textPosition: TextPosition;
}

const SliderPreview = ({ slider }: { slider: Slider }) => {
	return (
		<div className={`relative flex ${slider.textPosition === 'right' ? 'justify-end' : 'justify-start'} min-h-[119px]  min-w-[300px] max-w-[350px] bg-white shadow-md rounded-[12px] px-[16px] py-[px] flex flex-row items-center`} style={{ backgroundColor: slider.backgroundColor }}>
			<div className="flex flex-col gap-[6px] flex-1 ">
				<h2 className="text-lg font-bold flex-1" style={{ color: slider.color }}>
					{slider.name}
				</h2>
				<p className="text-sm flex-1" style={{ color: slider.color }}>
					{slider.description}
				</p>
			</div>

			{/* <div> */}
			<img src={getImage(slider.image)} alt={slider.name} className="max-w-[160px] h-[102px] object-fill" />
			{/* </div> */}
		</div>
	);
};

export default SliderPreview;
